export const toStripeAmount = (amount: string) => {
    return parseFloat(amount.replace('.', ''));
};
